<template>
  <div v-show="!isFull" id="nav" class="sidenav data-subnav nav-app">
    <ul>
      <li>
        <router-link to="/app/list">首页</router-link><span>
          <router-link to="/app/list">控制台首页</router-link>
        </span>
      </li>
      <li :class="[$route.path.includes('/browser')?'on':'', menuClass('browser')]">
        <span>
          <a href="javascript:;" @click.prevent="goMenu('browser', '/app/browser/' + appId)">数据</a>
        </span>
      </li>
      <li :class="[$route.path.includes('/mqtt')?'on':'', menuClass('mqtt')]">
        <span>
          <a href="javascript:;" @click.prevent="goMenu('mqtt', '/mqtt/index/' + appId)">IOT</a>
        </span>
      </li>
      <li :class="[($route.path.includes('cloud') || $route.path.includes('Cloud')) && ( !$route.path.includes('/upgrade') )?'on':'', menuClass('cloud')]">
        <a href="javascript:;" @click.prevent="goMenu('cloud', '/app/cloud/' + appId)">云函数</a>
      </li>
      <li :class="[isOn(['filemaintain','fileManager','filemanage','editfilethumbnail','editdomainacl','editipacl' , 'material','addMaterial','editMaterial','staticSite'])?'on':'', menuClass('fileManager')]">
        <a href="javascript:;" @click.prevent="goMenu('fileManager', '/app/fileManager/' + appId)">素材</a>
      </li>
      <li :class="[$route.path.includes('/appPay')?'on':'', menuClass('appPay')]">
        <a href="javascript:;" @click.prevent="goMenu('appPay', '/appPay/wechatlog/' + appId)">收益</a>
      </li>
      <li :class="[$route.path.includes('/sms') && !$route.path.includes('/upgrade')?'on':'', menuClass('sms')]">
        <a href="javascript:;" @click.prevent="goMenu('sms', '/sms/template/' + appId)">短信</a>
      </li>
      <li :class="[$route.path.includes('/analysis')?'on':'', menuClass('analysis')]">
        <a href="javascript:;" @click.prevent="goMenu('analysis', '/analysis/ApiAll/' + appId)">分析</a>
      </li>
      <li :class="[isOn(['appauth','domain','upgrade','edit','setemail','backuprestore','secret','config','appwebsite','audit','aiset','dataHook'])?'on':'', menuClass('secret')]">
        <a href="javascript:;" @click.prevent="goMenu('secret', '/app/secret/' + appId)">设置</a>
      </li>
    </ul>
  </div>
</template>
<script>
import { canAccessMenu, guardMenu, loadAppPermission } from '@/utils/appPermission'

export default {
  data() {
    return {
      appId: this.$route.params.appId,
      isFull: this.$route.path.includes('/browser') && this.$route.query.full,
      permReady: false
    }
  },
  watch: {
    '$route.params.appId'(val) {
      this.appId = val
      this.refreshPermission()
    }
  },
  mounted() {
    this.refreshPermission()
  },
  methods: {
    refreshPermission() {
      loadAppPermission(this.appId).then(() => {
        this.permReady = true
        this.$forceUpdate()
      })
    },
    menuClass(key) {
      if (!this.permReady) return ''
      return canAccessMenu(key) ? '' : 'no-perm'
    },
    goMenu(key, path) {
      guardMenu(key, () => {
        this.$router.push(path)
      })
    },
    isOn(arr) {
      var res = false
      var path = this.$route.path
      arr.forEach(e => {
        if (path.includes('/' + e + '/')) {
          res = true
        }
      })
      return res
    }
  }
}
</script>
<style scoped>
.no-perm > span > a,
.no-perm > a {
  opacity: 0.45;
}
</style>
